(function () {
  const Core = window.RB.Core;

  const hasPrintedOrGrantedKw = function (state, iid, kw) {
    const c = Core.card(state, iid);
    for (const k of (c && c.keywords) || []) {
      if (String(k.name).toLowerCase() === kw) return true;
    }
    const o = state.objs[iid];
    for (const g of (o && o.grants) || []) {
      if (g.k === "keyword" && String(g.name).toLowerCase() === kw) return true;
    }
    return false;
  };

  const ENEMY_ALONE_HERE = {
    k: "and",
    conds: [
      { k: "count", spec: { type: "unit", enemy: true, here: true }, n: 1, cmp: "exactly" },
      { k: "count", spec: { type: "unit", friendly: true, here: true, other: true }, n: 0, cmp: "exactly" },
    ],
  };

  const CONSCRIPT = function (spec, prompt) {
    return [
      { op: "choose", bind: "_c", spec: spec, prompt: prompt },
      { op: "takeControl", to: "$_c" },
      { op: "exhaust", to: "$_c" },
      { op: "move", to: "$_c", dest: "base" },
    ];
  };

  const MIGHT_BEATS_TOTAL_AT = function (bind) {
    const conds = [];
    for (let x = 0; x <= 24; x++) {
      conds.push({
        k: "and",
        conds: [
          { k: "selfMightAtLeast", n: x + 1 },
          { k: "totalMight", spec: { type: "unit", enemy: true, atBind: bind }, n: x, cmp: "atMost" },
        ],
      });
    }
    return { k: "or", conds: conds };
  };

  window.RB.CardLib = window.RB.CardLib || {};
  window.RB.CardLib.unl = { hasPrintedOrGrantedKw: hasPrintedOrGrantedKw, ENEMY_ALONE_HERE: ENEMY_ALONE_HERE, CONSCRIPT: CONSCRIPT, MIGHT_BEATS_TOTAL_AT: MIGHT_BEATS_TOTAL_AT };
})();
